import {
  GET_WALLET_BALANCES_FAILURE,
  GET_WALLET_BALANCES_STARTED,
  GET_WALLET_BALANCES_SUCCESS,
} from "redux/ActionTypes";
import { getWalletBalancesAPI } from "services/API/wallet";

export const getWalletBalancesRequestAction = () => {
  return async (dispatch) => {
    dispatch(getWalletBalancesStartedAction());
    try {
      let response = await getWalletBalancesAPI();
      if (!response.error) {
        dispatch(
          getWalletBalancesSuccessAction({ walletBalances: response.data })
        );
      } else {
        dispatch(getWalletBalancesFailureAction(response.data.error_message));
      }
    } catch (error) {
      dispatch(getWalletBalancesFailureAction(error.error_message));
    }
  };
};

export const getWalletBalancesStartedAction = () => ({
  type: GET_WALLET_BALANCES_STARTED,
});

export const getWalletBalancesSuccessAction = (payload) => ({
  type: GET_WALLET_BALANCES_SUCCESS,
  payload,
});

export const getWalletBalancesFailureAction = (message) => ({
  type: GET_WALLET_BALANCES_FAILURE,
  payload: message,
});
